import { ReactNode } from "react";
import styles from "./NavbarPill.module.scss";

interface NavbarPillProps {
  children: ReactNode;
  hasBg?: boolean;
}

export const NavbarPill = ({ children, hasBg }: NavbarPillProps) => {
  return (
    <div
      className={`${styles["navbar-pill"]} ${hasBg ? styles["navbar-pill--has-bg"] : ""}`}
    >
      {children}
    </div>
  );
};
